import { render, staticRenderFns } from "./DepartStat.vue?vue&type=template&id=d535411a"
import script from "./DepartStat.vue?vue&type=script&lang=js"
export * from "./DepartStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports